import Icon from '../../components/Icon.vue'

Icon.register({"brands/korvue":{"width":446,"height":512,"paths":[{"d":"M386.5 34H59.5C26.8 34 0 60.8 0 93.5V420.6C0 453.2 26.8 480 59.5 480H386.6C419.6 480 446.1 453.2 446.1 420.5V93.5C446 60.8 419.2 34 386.5 34zM87.1 120.8H183.1V236.8L244.9 120.8H355.8L274.6 252.8H87.1V120.8zM248.9 392.9L183.2 279.3V392.9H87.2V262.1H278.7L367.3 392.9H248.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/korvue.js
// module id = PAKh
// module chunks = 0